import React from 'react';
import { Flex, Button } from 'rebass';
import styled from 'styled-components';
import theme from '../../app/themes';

const ActionButton = styled(Button)`
  border-radius: 0;
  cursor: pointer;
  font-weight: normal;

  &, &:hover {
    box-shadow: 5px 5px 0 ${theme.colors.greyLight};
  }

  &:hover {
    background-color: ${theme.colors.black};
  }
`;

export default (props) => (
  <Flex
    justify="center"
    my={3}
  >
    <ActionButton
      f={2}
      py={3}
      px={4}
      color="white"
      bg="brand"
      {...props}
    />
  </Flex>
);



// WEBPACK FOOTER //
// ./src/Lead/button/index.js